module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('container', [_c('race-header', {
    attrs: {
      "title": "New Race"
    }
  }), _vm._v(" "), _c('custom-form', {
    staticStyle: {
      "marginBottom": "40px"
    },
    attrs: {
      "handle-submit": _vm.handleSubmit
    }
  }, [_c('text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "label": "Name",
      "name": "name",
      "maxlength": "5",
      "data-vv-value-path": "input",
      "data-vv-name": "name",
      "error-message": "Fill in the name",
      "has-error": _vm.errors.has('name'),
      "required": true
    },
    model: {
      value: (_vm.race.name),
      callback: function($$v) {
        _vm.$set(_vm.race, "name", $$v)
      },
      expression: "race.name"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form__group"
  }, [_c('label', {
    attrs: {
      "for": "description"
    }
  }, [_vm._v("Description "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.race.description),
      expression: "race.description"
    }],
    class: {
      'form-control': true, 'is-danger': _vm.errors.has('description')
    },
    attrs: {
      "data-vv-rules": "required",
      "name": "description",
      "rows": "6",
      "id": "txtArea",
      "onkeypress": "onDescriptionChange",
      "required": ""
    },
    domProps: {
      "value": (_vm.race.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.race, "description", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('description')),
      expression: "errors.has('description')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v("Fill in the description")])]), _vm._v(" "), _c('date-time-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "label": ("Date - " + (_vm.getTimezone())),
      "name": "date",
      "data-vv-value-path": "startDate.time",
      "data-vv-name": "date",
      "error-message": "Fill in the date",
      "has-error": _vm.errors.has('date'),
      "required": true
    },
    model: {
      value: (_vm.race.date),
      callback: function($$v) {
        _vm.$set(_vm.race, "date", $$v)
      },
      expression: "race.date"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form__group",
    staticStyle: {
      "display": "inline-flex"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isRepeatShift),
      expression: "isRepeatShift"
    }],
    attrs: {
      "type": "checkbox",
      "id": "repeatShift",
      "name": "repeatShift"
    },
    domProps: {
      "checked": Array.isArray(_vm.isRepeatShift) ? _vm._i(_vm.isRepeatShift, null) > -1 : (_vm.isRepeatShift)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.isRepeatShift,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isRepeatShift = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isRepeatShift = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isRepeatShift = $$c
        }
      }, function($event) {
        _vm.onChecked()
      }]
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "repeatShiftLabel",
    attrs: {
      "for": "repeat-shift"
    }
  }, [_vm._v("Repeat Shift")]), _vm._v(" "), _c('div', {
    class: {
      'hide': !_vm.isRepeatShift
    },
    staticStyle: {
      "display": "inline-flex"
    }
  }, [_c('span', {
    staticClass: "repeatEvery"
  }, [_vm._v("Repeat Every : ")]), _vm._v(" "), _c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.race.interval),
      expression: "race.interval"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: (_vm.isRepeatShift ? 'required' : ''),
      expression: "isRepeatShift?'required':''"
    }],
    staticClass: "repeatDays",
    attrs: {
      "name": "repeatDays",
      "required": _vm.isRepeatShift
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.race, "interval", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "EVERY_WEEK"
    }
  }, [_vm._v("Every Week")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "EVERY_2_WEEKS"
    }
  }, [_vm._v("Every 2 Weeks")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "EVERY_MONTH"
    }
  }, [_vm._v("Every Month")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('repeatDays')),
      expression: "errors.has('repeatDays')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v("Fill in the Repeat Days")])]), _vm._v(" "), _c('span', {
    staticClass: "ending"
  }, [_vm._v("Ending : ")]), _vm._v(" "), _c('date-time-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.isRepeatShift ? 'required' : ''),
      expression: "isRepeatShift?'required':''"
    }],
    staticClass: "endingDate",
    attrs: {
      "isRepeatField": true,
      "name": "endDate",
      "data-vv-value-path": "startDate.time",
      "data-vv-name": "endDate",
      "error-message": "Fill in the End date",
      "has-error": _vm.errors.has('endDate'),
      "data-vv-rules": _vm.isRepeatShift ? 'required' : '',
      "required": _vm.isRepeatShift
    },
    model: {
      value: (_vm.race.end_interval),
      callback: function($$v) {
        _vm.$set(_vm.race, "end_interval", $$v)
      },
      expression: "race.end_interval"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form__group"
  }, [_c('label', {
    attrs: {
      "for": "duration"
    }
  }, [_vm._v("Duration(in minutes):")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.race.duration),
      expression: "race.duration"
    }],
    class: {
      'form-control': true, 'is-danger': _vm.errors.has('duration')
    },
    attrs: {
      "data-vv-rules": "required",
      "type": "number",
      "step": "1",
      "min": "1",
      "max": _vm.max_duration,
      "name": "duration",
      "required": ""
    },
    domProps: {
      "value": (_vm.race.duration)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.race, "duration", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('duration')),
      expression: "errors.has('duration')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v("Fill in the duration")])]), _vm._v(" "), _c('div', {
    staticClass: "form__group"
  }, [_c('div', {
    staticStyle: {
      "display": "inline-flex"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-right": "100px"
    }
  }, [_c('label', {
    attrs: {
      "for": "type"
    }
  }, [_vm._v("First Type:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.race.type),
      expression: "race.type"
    }],
    staticStyle: {
      "height": "33px"
    },
    attrs: {
      "label": "First Type",
      "name": "type"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.race, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "LIVE"
    }
  }, [_vm._v(" Live (Medal) ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "NO_MEDAL"
    }
  }, [_vm._v(" No Medal ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ON_DEMAND_MEDAL"
    }
  }, [_vm._v(" On demand (Medal)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ON_DEMAND_NO_MEDAL"
    }
  }, [_vm._v(" On demand (No Medal) ")])])]), _vm._v(" "), (_vm.race.type == 'ON_DEMAND_MEDAL' || _vm.race.type == 'ON_DEMAND_NO_MEDAL') ? _c('div', [_c('race-media', {
    attrs: {
      "label": "On demand File",
      "name": "media",
      "data-vv-value-path": "input",
      "data-vv-name": "media",
      "error-message": "Fill in the audio",
      "has-error": _vm.errors.has('media'),
      "required": false
    },
    model: {
      value: (_vm.race.audioFileUrl),
      callback: function($$v) {
        _vm.$set(_vm.race, "audioFileUrl", $$v)
      },
      expression: "race.audioFileUrl"
    }
  })], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form__group"
  }, [_c('label', {
    attrs: {
      "for": "type"
    }
  }, [_vm._v("Second Type:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.race.secondType),
      expression: "race.secondType"
    }],
    attrs: {
      "label": " Second Type",
      "name": "secondType"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.race, "secondType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.raceTypes), function(type) {
    return _c('option', {
      domProps: {
        "value": type.name
      }
    }, [_vm._v(_vm._s(type.englishText))])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "form__group"
  }, [_c('label', {
    attrs: {
      "for": "type"
    }
  }, [_vm._v("Third Type:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.race.thirdType),
      expression: "race.thirdType"
    }],
    attrs: {
      "label": "Third Type",
      "name": "thirdType"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.race, "thirdType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(" NONE ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "NO_MEDAL"
    }
  }, [_vm._v(" NO MEDAL ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PromoL"
    }
  }, [_vm._v(" L ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PromoI"
    }
  }, [_vm._v(" I ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PromoV"
    }
  }, [_vm._v(" V ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PromoE"
    }
  }, [_vm._v(" E ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "LIVE_60MIN"
    }
  }, [_vm._v(" 60MIN_MEDAL ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PromoU"
    }
  }, [_vm._v(" U ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PromoR"
    }
  }, [_vm._v(" R ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "MEDAL_20K"
    }
  }, [_vm._v(" 20Km Medal ")])])]), _vm._v(" "), _c('div', {
    staticClass: "form__group"
  }, [_c('label', {
    attrs: {
      "for": "type"
    }
  }, [_vm._v("Channel:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.race.mobileChannelToPlay),
      expression: "race.mobileChannelToPlay"
    }],
    staticStyle: {
      "width": "9%"
    },
    attrs: {
      "label": "Channel",
      "name": "channel"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.race, "mobileChannelToPlay", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": _vm.channels.audioChannelA
    }
  }, [_vm._v(" A ")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.channels.audioChannelB
    }
  }, [_vm._v(" B ")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.channels.audioChannelC
    }
  }, [_vm._v(" C ")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.channels.audioChannelD
    }
  }, [_vm._v(" D ")])])]), _vm._v(" "), _c('div', {
    staticClass: "form__group"
  }, [_c('label', {
    attrs: {
      "for": "type"
    }
  }, [_vm._v(" Language:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.race.language),
      expression: "race.language"
    }],
    attrs: {
      "label": "Language",
      "name": "language"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.race, "language", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.locales), function(locale) {
    return _c('option', {
      domProps: {
        "value": locale.id
      }
    }, [_vm._v(_vm._s(locale.name))])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "form__group"
  }, [_c('label', {
    attrs: {
      "for": "type"
    }
  }, [_vm._v("RSVP Limit:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.race.rsvp_limit),
      expression: "race.rsvp_limit"
    }],
    class: {
      'form-control': true, 'is-danger': _vm.errors.has('rsvp_limit')
    },
    attrs: {
      "data-vv-rules": "required",
      "type": "number",
      "step": "1",
      "min": "1",
      "max": _vm.max_rsvp_limit,
      "name": "rsvp_limit",
      "required": ""
    },
    domProps: {
      "value": (_vm.race.rsvp_limit)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.race, "rsvp_limit", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('rsvp_limit')),
      expression: "errors.has('rsvp_limit')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v("Fill in the RSVP limit")])]), _vm._v(" "), _c('div', {
    staticClass: "form__group",
    staticStyle: {
      "display": "inline-flex"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "34rem",
      "margin-right": "20px"
    }
  }, [_c('label', {
    attrs: {
      "for": "type"
    }
  }, [_vm._v("Action URL:")]), _vm._v(" "), _c('text-field', {
    attrs: {
      "name": "endSessionUrl",
      "data-vv-value-path": "input",
      "data-vv-name": "name"
    },
    model: {
      value: (_vm.race.endSessionUrl),
      callback: function($$v) {
        _vm.$set(_vm.race, "endSessionUrl", $$v)
      },
      expression: "race.endSessionUrl"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "35rem"
    }
  }, [_c('race-photo', {
    attrs: {
      "label": "Action Image",
      "name": "actionImage",
      "data-vv-value-path": "input",
      "data-vv-name": "actionImage",
      "error-message": "Fill in the photo with size below 200 Kb",
      "has-error": _vm.errors.has('actionImage'),
      "required": false
    },
    model: {
      value: (_vm.race.actionImageUrl),
      callback: function($$v) {
        _vm.$set(_vm.race, "actionImageUrl", $$v)
      },
      expression: "race.actionImageUrl"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form__group race-tags"
  }, [_c('label', {
    attrs: {
      "for": "type"
    }
  }, [_vm._v(" Tags:")]), _vm._v(" "), _c('selectize', {
    staticStyle: {
      "visibility": "hidden"
    },
    attrs: {
      "options": _vm.tagsOptions,
      "multiple": "",
      "size": "1",
      "isRunnerTag": false,
      "data-dropdown-parent": "body",
      "data-max-options": "100",
      "data-value-field": "id",
      "data-label-field": "name",
      "data-search-field": "name",
      "data-sort-field": "name"
    },
    model: {
      value: (_vm.selectedTags),
      callback: function($$v) {
        _vm.selectedTags = $$v
      },
      expression: "selectedTags"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form__group",
    staticStyle: {
      "display": "inline-flex"
    }
  }, [_c('label', {
    staticClass: "randomClubTag",
    attrs: {
      "for": "randomClubTag"
    }
  }, [_vm._v("Random Club Tag : ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.race.randomClubTag),
      expression: "race.randomClubTag"
    }],
    staticStyle: {
      "transform": "scale(1.3)",
      "margin": "2px 9px"
    },
    attrs: {
      "type": "checkbox",
      "id": "randomClubTag",
      "name": "randomClubTag"
    },
    domProps: {
      "checked": Array.isArray(_vm.race.randomClubTag) ? _vm._i(_vm.race.randomClubTag, null) > -1 : (_vm.race.randomClubTag)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.race.randomClubTag,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.race.randomClubTag = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.race.randomClubTag = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.race, "randomClubTag", $$c)
        }
      }
    }
  })]), _vm._v(" "), _c('div', [(_vm.race.imageUrl) ? _c('div', [_c('p', [_vm._v("Current photo race:")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.race.imageUrl,
      "width": "200px"
    }
  })]) : _vm._e(), _vm._v(" "), _c('upload-photo', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "label": "Photo",
      "name": "photo",
      "data-vv-value-path": "input",
      "data-vv-name": "photo",
      "error-message": "Fill in the photo with size below 200 Kb",
      "has-error": _vm.errors.has('photo'),
      "required": true
    },
    model: {
      value: (_vm.race.imageUrl),
      callback: function($$v) {
        _vm.$set(_vm.race, "imageUrl", $$v)
      },
      expression: "race.imageUrl"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form__group"
  }, [_c('label', {
    attrs: {
      "for": "type"
    }
  }, [_vm._v(" Trainer:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.trainerId),
      expression: "trainerId"
    }],
    staticClass: "trainer-list",
    attrs: {
      "label": "Trainer",
      "name": "Trainer"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.trainerId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.changeTrainer]
    }
  }, _vm._l((_vm.trainerList), function(trainer, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": trainer.id
      }
    }, [_vm._v(_vm._s(trainer.firstName))])
  }))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn--primary",
    attrs: {
      "id": "submit-form"
    }
  }, [_vm._v("Create Race")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn--primary",
    attrs: {
      "to": "/admin/races",
      "id": "Cancel"
    }
  }, [_vm._v("Cancel")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e8fd155a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Races/Create.vue
// module id = 1719
// module chunks = 1